<script>
	import MediaPlayerComponent from 'src/components/MediaPlayerComponent.svelte';
	import { devices } from 'src/stores/lists/devices';

	export let mediaWidget;

	$: device = $devices[mediaWidget.id];
</script>

<MediaPlayerComponent {mediaWidget} {device} dashWidgetVariant={true} on:click />
